import { render, staticRenderFns } from "./listaFilas.vue?vue&type=template&id=10404f9f&scoped=true"
import script from "./listaFilas.vue?vue&type=script&lang=js"
export * from "./listaFilas.vue?vue&type=script&lang=js"
import style0 from "./listaFilas.vue?vue&type=style&index=0&id=10404f9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10404f9f",
  null
  
)

export default component.exports